import React from 'react';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';

let originalProductArray = '';
let selectedFilters = {};
let newBadgeConst = new Date();

class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterOptionArray: {},
            isFilterActive: false
        };
    }

    componentDidMount() {
        selectedFilters = {};
        newBadgeConst.setDate(newBadgeConst.getDate() - (this.props.newBadgeDays && this.props.newBadgeDays.data && !isNaN(JSON.parse(this.props.newBadgeDays.data).days) ? JSON.parse(this.props.newBadgeDays.data).days : 30));

        originalProductArray = this.props.productArray;
        let filterOptionArray = {};
        if(this.props.productArray) {
            this.props.productArray.map(product => {
                for(let attr in product) {
                    if (attr === 'meta') {
                        let value = (product[attr] && product[attr].createdAt && new Date(product[attr].createdAt) < newBadgeConst);
                        if(typeof filterOptionArray["newproduct"] === 'undefined') {
                            filterOptionArray["newproduct"] = [];
                            filterOptionArray["newproduct"].push(value);
                        } else {
                            filterOptionArray["newproduct"].push(value);
                        }
                    } else {
                        if(typeof filterOptionArray[attr] === 'undefined') {
                            filterOptionArray[attr] = [];
                            filterOptionArray[attr].push(product[attr]);
                        } else {
                            filterOptionArray[attr].push(product[attr]);
                        }
                    }
                }
            });
        }

        this.setState({
            filterOptionArray: filterOptionArray,
            searchTerm: this.props.searchTerm ? this.props.searchTerm : ''
        });
    }

    /**
     * @function hasJsonStructure
     * @desc this function verify if the filter value has a JSON structure
     * 
     * @param {str} - filter value
     */
    hasJsonStructure = (str) => {
        if (typeof str !== 'string') return false;
        try {
            const result = JSON.parse(str);
            const type = Object.prototype.toString.call(result);
            return type === '[object Object]' 
                || type === '[object Array]';
        } catch (err) {
            return false;
        }
    }

    /**
     * @function createFilter
     * @desc this function creates the filter passed by into the filter's popup
     * 
     * @param {filter} - filter array
     * @param {filterName} - string
     */
    createFilter = (filter, filterName) => {
        let tempFilter = [];
        //Recover unique elements
        tempFilter = _.uniqBy(filter, function (e) {
            return e;
        });
        //Sort filter
        if (!this.hasJsonStructure(filter[0])) {
            tempFilter = _.uniqBy(filter, function (e) {
                return e;
            });
            tempFilter.sort((a, b) => {
                if(a === b) {
                    return (a < b) ? -1 : (a > b) ? 1 : 0;
                } else {
                    return (a < b) ? -1 : 1;
                }
            })
        } else {
            tempFilter = _.uniqBy(filter, function (e) {
                return e;
            });
            tempFilter.sort((a, b) => {
                let jsonA = JSON.parse(a);
                let jsonB = JSON.parse(b);
                let jsonAValues = [];
                let jsonBValues = [];
                let localeFilterA = '';
                let localeFilterB = '';
                
                for(let keyA in jsonA) {
                    jsonAValues = jsonA[keyA];
                    jsonAValues = jsonAValues[0];
                    localeFilterA = jsonAValues[(this.props.locale).toUpperCase()];
                }
                for(let keyB in jsonB) {
                    jsonBValues = jsonB[keyB];
                    jsonBValues = jsonBValues[0];
                    localeFilterB = jsonBValues[(this.props.locale).toUpperCase()];
                }

                if(localeFilterA === localeFilterB) {
                    return (localeFilterA < localeFilterB) ? -1 : (localeFilterA > localeFilterB) ? 1 : 0;
                } else {
                    return (localeFilterA < localeFilterB) ? -1 : 1;
                }
            });
        }
        return (
            <>
             {
                 tempFilter.map((option, index) => {
                    if (option) {
                        if (filterName === 'newproduct') {
                            return (
                                <li className={"filter__option filter__" + filterName + "-" + option + (parseInt(index) > 4 ? ' longfilter' : '')} key={index}>
                                    <label>
                                        <input type="checkbox" name={filterName} value={option} onClick={this.handleFilterChange}/>
                                        {i18next.t("FILTER_NEW_LABEL")}
                                    </label>
                                </li>
                            )  
                        } else if(!this.hasJsonStructure(option)) {
                            return (
                                <li className={"filter__option filter__" + filterName + "-" + option + (parseInt(index) > 4 ? ' longfilter' : '')} key={index}>
                                    <label>
                                        <input type="checkbox" name={filterName} value={option} onClick={this.handleFilterChange}/>
                                        {option.toLowerCase()}
                                    </label>
                                </li>
                            )                      
                        } else {
                            let jsonOption = JSON.parse(option);
                            let jsonOptionValue = [];
                            let localeFilterOption = '';
                            let filterId = '';
                            for(let key in jsonOption) {
                                filterId = key;
                                jsonOptionValue = jsonOption[key];
                                jsonOptionValue = jsonOptionValue[0];
                                localeFilterOption = jsonOptionValue[(this.props.locale).toLowerCase()];
                            }

                            return (
                                <li className={"filter__option filter__" + filterName + "-" + filterId + (parseInt(index) > 4 ? ' longfilter' : '')} key={index}>
                                    <label>
                                        <input type="checkbox" name={filterName} value={filterId} onClick={this.handleFilterChange}/>
                                        {localeFilterOption}
                                    </label>
                                </li>
                            )
                        }
                    } else {
                        return '';
                    }
                 })
             }
            </>
        );
    }

    /**
     * @function handleFilterChange
     * @desc this function select or deselect the filter clicked and shows the product list filtered 
     * 
     * @param {e}
     */
    handleFilterChange = (e) => {
        e.target.parentNode.classList.toggle('active');
        if(e.target.parentNode.classList.contains('active')) {
            if(typeof selectedFilters[e.target.name] === 'undefined') {
                selectedFilters[e.target.name] = [];
                selectedFilters[e.target.name].push(e.target.value);
            } else {
                selectedFilters[e.target.name].push(e.target.value);
            }
            if(e.target.value === 'Man' || e.target.value === 'Woman') {
                selectedFilters[e.target.name].push('Unisex');
            }
        } else {
            if(selectedFilters[e.target.name].length === 1) {
                delete selectedFilters[e.target.name];
            } else {
                selectedFilters[e.target.name].splice( selectedFilters[e.target.name].indexOf(e.target.value), 1 );
            }
            if(e.target.value === 'Man' || e.target.value === 'Woman') {
                selectedFilters[e.target.name].splice( selectedFilters[e.target.name].indexOf('Unisex'), 1 );
            }
        }

        var filteredArray = originalProductArray.filter(product => {
            for (var filter in selectedFilters) {
                if (filter === 'newproduct') {
                    let value = (product["meta"] && product["meta"].createdAt && new Date(product["meta"].createdAt) < newBadgeConst);
                    let count = 0;
                    for(var option = 0; option < selectedFilters[filter].length; option++) {
                        if(value.toString() === selectedFilters[filter][option]) {
                            count++;
                        }
                    }
                    if(count === 0) {
                        return false;
                    }
                } else if (product[filter] !== undefined) {
                    let count = 0;
                    for(var option = 0; option < selectedFilters[filter].length; option++) {
                        if(!this.hasJsonStructure(product[filter])) {
                            if(product[filter] === selectedFilters[filter][option]) {
                                count++;
                            }
                        } else {
                            let jsonFilter = JSON.parse(product[filter]);
                            let filterOption = '';
                            for(let key in jsonFilter) {
                                filterOption = key;
                            }
                            if(filterOption === selectedFilters[filter][option]) {
                                count++;
                            }
                        }
                    }
                    if(count === 0) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
            return true;
        });
        if(_.isEmpty(selectedFilters)) {
            this.setState({
                isFilterActive: false
            });
            if(typeof this.props.setIsFilterActive !== 'undefined') {
                this.props.setIsFilterActive(false);
            }
        } else {
            this.setState({
                isFilterActive: true
            });
            if(typeof this.props.setIsFilterActive !== 'undefined') {
                this.props.setIsFilterActive(true);
            }
        }
        this.props.handleFilter(filteredArray);
    }

    /**
     * @function handleOpenFilterModal
     * @desc this function open the filter popup
     */
    handleOpenFilterModal = () => {
        if (document.querySelector('.sort-by__title')) {
            document.querySelector('.sort-by__title').classList.remove('opend');
            document.querySelector('.sort-by__title').parentElement.classList.remove('opend');
        }
        if (document.querySelector('.shownelements__title')) {
            document.querySelector('.shownelements__title').classList.remove('opend');
            document.querySelector('.shownelements__title').parentElement.classList.remove('opend');
        }
        if (document.querySelector('.filter__title')) {
            document.querySelector('.filter__title').classList.toggle('opend');
            document.querySelector('.filter__title').parentElement.classList.toggle('opend');
        }

        if(this.props.searchTerm && this.state.searchTerm) {
            if(_.isEmpty(originalProductArray) || this.state.searchTerm !== this.props.searchTerm) {
                originalProductArray = this.props.productArray
                let filterOptionArray = {};
                this.props.productArray.map(product => {
                    for(let attr in product) {
                        if (attr === 'meta') {
                            let value = (product[attr] && product[attr].createdAt && new Date(product[attr].createdAt) < newBadgeConst);
                            if(typeof filterOptionArray[attr] === 'undefined') {
                                filterOptionArray["newproduct"] = [];
                                filterOptionArray["newproduct"].push(value);
                            } else {
                                filterOptionArray["newproduct"].push(value);
                            }
                        } else {
                            if(typeof filterOptionArray[attr] === 'undefined') {
                                filterOptionArray[attr] = [];
                                filterOptionArray[attr].push(product[attr]);
                            } else {
                                filterOptionArray[attr].push(product[attr]);
                            }
                        }
                    }
                });

                this.setState({
                    filterOptionArray: filterOptionArray,
                    searchTerm: this.props.searchTerm ? this.props.searchTerm : ''
                });
            }
        }
    }

    /**
     * @function resetFilters
     * @desc this function deselect all the filters selected
     */
    resetFilters = () => {
        this.setState({
            isFilterActive: false
        });
        if(typeof this.props.setIsFilterActive !== 'undefined') {
            this.props.setIsFilterActive(false);
        }
        selectedFilters = {};
        document.querySelectorAll('.filter__option .active').forEach(function(filter){
            filter.classList.remove('active');
        });
        this.props.handleFilter(originalProductArray);
    }

    /**
     * @function checkSingleFilter
     * @desc this function checks if the filter has only 1 option.
     */
    checkSingleFilter = (filterArray) => {
        let tempArray = _.uniqBy(filterArray, function (e) {
            return e;
        });
        const index = tempArray.indexOf("Unisex");
        if (index > -1) {
            tempArray.splice(index, 1);
        }
        return tempArray.length <= 1;
    }

    /**
     * @function getRealLength
     * @desc this function recover the length of the array by unique elements
     */
    getRealLength = (filterArray) => {
        let tempArray = _.uniqBy(filterArray, function (e) {
            return e;
        });
        return tempArray.length;
    }

    /**
     * @function seeMore
     * @desc When the user clcik in 'see+' button, the menu grows showing more options
     */
    seeMore = (e, classname) => {
        document.getElementsByClassName("filter__options").forEach(element => {
            if (!element.classList.contains(classname)) {
                element.classList.remove("expand");
            }
        });
        document.getElementsByClassName("seemore").forEach(element => {
            element.innerHTML = i18next.t("FILTER_SHOWALL");
        });
        document.getElementsByClassName(classname)[0].classList.toggle("expand");
        document.getElementsByClassName("filter__wrapper")[0].classList.toggle("expand");

        if (document.getElementsByClassName(classname)[0].classList.contains("expand")) {
            e.target.innerHTML = i18next.t("FILTER_SHOWLESS");
        }
    }

    render() {
        const filters = [
            {
                title: "FILTER_CATEGORY",
                filterArray: this.state.filterOptionArray.categoria,
                name: 'categoria'
            },
            {
                title: "FILTER_GENDER",
                filterArray: this.state.filterOptionArray.sexo,
                name: 'sexo'
            },
            {
                title: "FILTER_BRAND",
                filterArray: this.state.filterOptionArray.marca,
                name: 'marca'
            },
            {
                title: "FILTER_COLORM",
                filterArray: this.state.filterOptionArray.colormont,
                name: 'colormont'
            },
            {
                title: "FILTER_MATERIAL",
                filterArray: this.state.filterOptionArray.material,
                name: 'material'
            },
            {
                title: "FILTER_LENS",
                filterArray: this.state.filterOptionArray.colorcrist,
                name: 'colorcrist'
            },
            {
                title: "FILTER_NEW",
                filterArray: this.state.filterOptionArray.newproduct,
                name: 'newproduct'
            }
        ];
        return(
            <>
                <div className="filter">
                    <div className="filter__title" onClick={this.handleOpenFilterModal} onKeyDown={this.handleOpenFilterModal} tabIndex="0">
                        {i18next.t("FILTER")}
                        <FontAwesomeIcon className="filter__title-icon" icon="angle-down" />
                    </div>
                    <div className="filter__fade" onClick={this.handleOpenFilterModal}></div>
                    <div className="filter__box">
                        <div className="filter__reset">
                            { this.state.isFilterActive ?
                                <div>
                                    <button onClick={this.handleOpenFilterModal} onKeyDown={this.handleOpenFilterModal}>{i18next.t("FILTER_SHOW")}</button>
                                    <button onClick={this.resetFilters} onKeyDown={this.resetFilters}>{i18next.t("FILTER_RESET")}</button>
                                </div>
                                :
                                <span>{i18next.t("FILTER_TITLE")}</span>
                            }
                        </div>
                        {
                            _.isEmpty(this.state.filterOptionArray) ? '' : 
                            <div className="filter__wrapper">
                                {filters.map((filter, index) => {
                                    return(
                                        !this.checkSingleFilter(filter.filterArray) &&
                                        <div className={"filter__list filter__list--" + filter.name} key={index}>
                                            <span className="filter__header">{i18next.t(filter.title)}</span>
                                            <ul className={"filter__options filter__" + filter.name}>
                                                {this.createFilter(filter.filterArray, filter.name)}
                                            </ul>
                                            {this.getRealLength(filter.filterArray) > 5 ? <span className="seemore" onClick={(event) => this.seeMore(event, "filter__" + filter.name)}>{i18next.t("FILTER_SHOWALL")} </span> : ''}
                                        </div>
                                    );
                                })}
                            </div>
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default Filter;
